<mat-expansion-panel [formGroup]="messagesForm">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Error Messages
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div formArrayName="errorMessages" class="d-sm-flex flex-column">
        <p>Error messages are shown when a response fails or fails sanitization.</p>
        @for (message of errorMessages.controls; track trackByIndex(i, message); let i = $index) {
            <div [formGroupName]="i" class="message-item d-sm-flex">
                <!-- Error Message Field -->
                <mat-form-field appearance="fill" class="full-width w-100">
                    <mat-label>Error Message {{ i + 1 }}</mat-label>
                    <textarea formControlName="message" matInput placeholder="Enter error message" rows="2"></textarea>
                    @if (message.get('message')?.invalid && message.get('message')?.touched) {
                        <mat-error>
                            Error message is required
                        </mat-error>
                    }
                </mat-form-field>
                <!-- Remove Button -->
                <app-disabled-button-reason [disabled]="errorMessageRemoveDisabled"
                                            [reason]="errorMessageRemoveDisabledReason">
                    <button (click)="removeErrorMessage(i)" [disabled]="errorMessageRemoveDisabled" aria-label="Remove error message" color="warn"
                            mat-icon-button type="button">
                        <mat-icon>delete</mat-icon>
                    </button>
                </app-disabled-button-reason>
            </div>
        }
        <button mat-button color="primary" type="button" (click)="addErrorMessage()">
            <mat-icon>add</mat-icon>
            Add Error Message
        </button>
    </div>
</mat-expansion-panel>

<mat-expansion-panel [formGroup]="messagesForm">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Wait Messages
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div formArrayName="waitMessages" class="d-sm-flex flex-column">
        <p>Wait messages are shown when there are delays in receiving a response.</p>
        @for (message of waitMessages.controls; track trackByIndex(i, message); let i = $index) {
            <div [formGroupName]="i" class="message-item d-sm-flex">
                <!-- Wait Message Field -->
                <mat-form-field appearance="fill" class="full-width w-100">
                    <mat-label>Wait Message {{ i + 1 }}</mat-label>
                    <textarea formControlName="message" matInput placeholder="Enter wait message" rows="2"></textarea>
                    @if (message.get('message')?.invalid && message.get('message')?.touched) {
                        <mat-error>
                            Wait message is required
                        </mat-error>
                    }
                </mat-form-field>
                <!-- Remove Button -->
                <app-disabled-button-reason [disabled]="waitMessageRemoveDisabled"
                                            [reason]="waitMessageRemoveDisabledReason">
                    <button (click)="removeWaitMessage(i)" [disabled]="waitMessageRemoveDisabled" aria-label="Remove wait message" color="warn"
                            mat-icon-button type="button">
                        <mat-icon>delete</mat-icon>
                    </button>
                </app-disabled-button-reason>
            </div>
        }
        <button mat-button color="primary" type="button" (click)="addWaitMessage()">
            <mat-icon>add</mat-icon>
            Add Wait Message
        </button>
    </div>
</mat-expansion-panel>
